import styled from 'styled-components';

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  
  .checklist-title-input {
    display: none;
  }
  .ant-form-item {
    margin-bottom: 4px;
  }

  .completed-label {
    color: ${({ theme }) => theme.colors.primary.grey};
  }

  ${({ isIcon }) =>
    isIcon &&
    `
    & > div:last-child {
        cursor: pointer;
        margin-left: 18px;
        height: 20px;
        margin-bottom: 4px;
        margin-top: 6px;
    }
  `}
`;

export const FormListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .ant-form-item {
    min-width: 288px;
    word-break: break-all;
  }

  .checkpoint-input {
    margin-bottom: 10px;
  }
`;

export const FormListTitle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  margin-top: 10px;
  .ant-btn {
    padding: 0;
    :disabled {
      background-color: transparent;
      > div {
        color: #a7aeba;
      }
    }
  }
`;
